var map = {
	"./de/mecha-active-btn.png": "P08C",
	"./en/mecha-active-btn.png": "H7c0",
	"./es/mecha-active-btn.png": "anm/",
	"./fr/mecha-active-btn.png": "BcUR",
	"./ja/mecha-active-btn.png": "ha2Y",
	"./ko/mecha-active-btn.png": "B9l6",
	"./pt/mecha-active-btn.png": "1zYD",
	"./ru/mecha-active-btn.png": "aGcK",
	"./tc/mecha-active-btn.png": "Bwbt",
	"./th/mecha-active-btn.png": "sAJx"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "PjZK";